import { useQuery } from 'react-query';
import { Place } from 'src/core/types';

import axios from './axios';

export interface UseScheduleCompatiblePlacesProps {
  start_datetime: string | null;
  duration: string;
  is_recurring: boolean;
  schedule?: {
    count: number;
    end_date: string | null;
    frequency: number;
    limit_type: 'count' | 'date';
    month_recurrence_type: 'day' | 'week';
    recurring_month_day: number | null;
    recurring_month_week: number | null;
    recurring_weekday: number | null;
    recurring_weekdays: string;
    start_date: string;
    start_time: string;
    type: 'daily' | 'weekly' | 'monthly';
  };
}

const fetchScheduleCompatiblePlaces = (
  scheduleCompatibility: UseScheduleCompatiblePlacesProps,
) => {
  return axios
    .post<Array<Place>>(
      '/posht/yashar/meeting-places/schedule-compatible/',
      scheduleCompatibility,
    )
    .then((res) => res.data);
};

export function useScheduleCompatiblePlaces(
  props: UseScheduleCompatiblePlacesProps,
) {
  return useQuery<Array<Place>>(
    ['places'],
    async () => {
      return fetchScheduleCompatiblePlaces(props);
    },
    {
      enabled: false,
      suspense: false,
    },
  );
}
